module.exports = __webpack_public_path__ + "static/media/dz.1d370766.svg";